<template>
    <div class="comingsoon">
        <div class="centered">敬请期待</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    activated() {
    }
}
</script>
<style lang="scss" scoped>
/* pageFullScreen在index.css */
.comingsoon {
    display: grid;
    place-items: center; 

    .centered {
        padding: 20px;

    }
}
</style>
